export default __webpack_public_path__ + "static/rumpledLinens-0dbc5f7dfebb607e3dc6e535fc3eadb9.svg";